import { render } from "./bank_accounts.vue?vue&type=template&id=5a07498a"
import script from "./bank_accounts.vue?vue&type=script&lang=js"
export * from "./bank_accounts.vue?vue&type=script&lang=js"

import "./bank_accounts.vue?vue&type=style&index=0&id=5a07498a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__